interface QueueExportBase {
    successEnabled: boolean
    cancelEnabled: boolean
    failureEnabled: boolean

}

export interface SQSExport extends QueueExportBase {
    sqsEnabled: boolean
}

export interface AQSExport extends QueueExportBase {
    aqsEnabled: boolean
}

export interface PubSubExport extends QueueExportBase {
    pubsubEnabled: boolean
}

export type MetlQueueExport = SQSExport | AQSExport | PubSubExport

export function isSQSExport(queueExport: MetlQueueExport): queueExport is SQSExport {
    return 'sqsEnabled' in queueExport
}

export function isAQSExport(queueExport: MetlQueueExport): queueExport is AQSExport {
    return 'aqsEnabled' in queueExport
}

export function isPubSubExport(queueExport: MetlQueueExport): queueExport is PubSubExport {
    return 'pubsubEnabled' in queueExport
}

export function isQueueEnabled(queueExport: MetlQueueExport): boolean {
    if(isAQSExport(queueExport))
        return queueExport.aqsEnabled
    else if(isPubSubExport(queueExport))
        return queueExport.pubsubEnabled
    else
        return queueExport.sqsEnabled
}